import React, {
  FC, useState, useEffect, useContext,
} from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { CardStatistics } from '@/components/CardStatistics';
import { IFields, TypeStatisticsEnum } from '@/components/CardStatistics/types';
import { AddCardStatistics } from '@/components/CardStatistics/AddCardStatistics';
import { EDIT_GLO_OPTIONS, GET_GLO_OPTIONS } from '@/gql/query/common';
import get from 'lodash/get';
import { STORAGE_KEY_CONFIG_STATISTICS } from '@/constants/storage';
import { getItem, saveItem } from '@/utils/storage';
import isEqual from 'lodash/isEqual';
import { UserContext } from '@/providers/UserProvider';
import { IProps } from './types';
import useStyles from './styles';

const WidjetCardStatistics: FC<IProps> = ({
  filterByDate, type, isCompare, compareDate, color, path, id,
}) => {
  const classes = useStyles();

  const { user } = useContext(UserContext);
  const role = user?.role || '';
  const [editGloOptions] = useMutation(EDIT_GLO_OPTIONS);

  const { statistics: options } = get(useQuery(GET_GLO_OPTIONS), `data.getGloOptions.${path}`) || [];
  const storage = JSON.parse(getItem(STORAGE_KEY_CONFIG_STATISTICS) || 'null');
  const [statistics, setStatistics] = useState<IFields[]>([]);

  useEffect(() => {
    const newStatistics = (storage && role && storage[role] && storage[role][id]) ? storage[role][id] : options;
    if (!isEqual(statistics, newStatistics)) {
      setStatistics(newStatistics);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, options, storage]);

  useEffect(() => {
    const newStatistics = options;
    if (!isEqual(statistics, newStatistics)) {
      setStatistics(newStatistics);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, options]);

  return (
    <section className={classes.containerOverflow}>
      <section className={classes.container}>
        {
          statistics.map((item) => (
            <CardStatistics
              key={item.id}
              id={item.id || ''}
              filterByDate={filterByDate}
              type={item.type || TypeStatisticsEnum.EVENTS}
              isRemove
              handleRemove={handleRemove}
              field={item.field}
              handleEdit={handleEdit}
              isCompare={isCompare}
              compareDate={compareDate}
              color={color}
            />
          ))
        }
        <AddCardStatistics handleAdd={handleAdd} type={type} color={color} />
      </section>
    </section>
  );

  function handleRemove(id: string) {
    const newStatistics = statistics.filter((item) => item.id !== id);
    saveToStorage(newStatistics);
    setStatistics(newStatistics);
    updateOptions(newStatistics);
  }

  function handleAdd(fields: IFields) {
    const newStatistics = statistics.concat(fields);
    saveToStorage(newStatistics);
    setStatistics(newStatistics);
    updateOptions(newStatistics);
  }

  function handleEdit(id: string, fields: IFields) {
    const newStatistics = statistics.map((item) => (item.id === id ? { ...item, field: fields.field } : item));
    saveToStorage(newStatistics);
    setStatistics(newStatistics);
    updateOptions(newStatistics);
  }

  function updateOptions(fields: IFields[]) {
    editGloOptions({
      variables: {
        type: `${path}.statistics`,
        options: fields,
      },
    });
  }

  function saveToStorage(newStatistics: IFields[]) {
    if (role) {
      const storage = JSON.parse(getItem(STORAGE_KEY_CONFIG_STATISTICS) || 'null') || {};
      saveItem(STORAGE_KEY_CONFIG_STATISTICS,
        JSON.stringify({ ...storage, [role]: { ...storage[role], [id]: newStatistics } }));
    }
  }
};

export default WidjetCardStatistics;
